'use strict';

var psrApp = angular.module('psrApp', [
	'ngRoute',
	'ngSanitize',
	'ngCookies',
	'ui.bootstrap',
	'ngDfp',
	'angular-loading-bar',
	'psrApp.services',
	'psrApp.controllers',
	'psrApp.directives'
]);

psrApp.config([
	'$routeProvider',
	'$locationProvider',
	'DoubleClickProvider',
	'$sceDelegateProvider',
	function ($routeProvider, $locationProvider, DoubleClickProvider, $sceDelegateProvider, $templateCache) {
		$routeProvider.when('/', { templateUrl: 'home.html', controller: 'HomeCtrl' });
		$locationProvider.html5Mode(true);

        DoubleClickProvider.collapseEmptyDivs();

		DoubleClickProvider.setPageTargeting("canal","home");
		DoubleClickProvider.setPageTargeting("psrChannel","home");
		DoubleClickProvider.setPageTargeting("psrIsIdentified","falso");
		DoubleClickProvider.setPageTargeting("psrReceiveAlert","naoAssino");
		DoubleClickProvider.setPageTargeting("psrReceiveEmailMkt","naoAssino");
		DoubleClickProvider.setPageTargeting("psrHasBirthHour","nao");
		DoubleClickProvider.setPageTargeting("psrHasBirthDay","nao");
		DoubleClickProvider.setPageTargeting("psrReceiveEmailNews","naoAssino");
		DoubleClickProvider.setPageTargeting("psrBirthMonth","nao");
		DoubleClickProvider.setPageTargeting("psrCurrentPage","/");
		DoubleClickProvider.setPageTargeting("psrHasAccessBook1","nao");
		DoubleClickProvider.setPageTargeting("psrIsArticlePage","nao");
		DoubleClickProvider.setPageTargeting("psrIsChannelCover","nao");
		DoubleClickProvider.setPageTargeting("psrIsSellPage","nao");
		DoubleClickProvider.setPageTargeting('psrPartner', "psr");
		DoubleClickProvider.setPageTargeting('partner', "psr");

		var _ttprofiles = window._ttprofiles || [];

		DoubleClickProvider.setPageTargeting("gender",_ttprofiles.getGender);
		DoubleClickProvider.setPageTargeting("cluster",_ttprofiles.getProfiles);
		DoubleClickProvider.setPageTargeting("subjects",_ttprofiles.getSubjects);
		DoubleClickProvider.setPageTargeting("team",_ttprofiles.getTeam);
		DoubleClickProvider.setPageTargeting("sclass",_ttprofiles.getSocialClass);
		DoubleClickProvider.setPageTargeting("msegments",_ttprofiles.getMicrosegments);
		DoubleClickProvider.setPageTargeting("occurrences",_ttprofiles.getOccurrences);
		DoubleClickProvider.setPageTargeting("equipment",_ttprofiles.getEquipment);

		DoubleClickProvider.defineSlot('/8948849/336x280', [[300, 250], [336, 280]], 'psr-ads-336x280');
        DoubleClickProvider.defineSlot('/8948849/psr_HgFc1eC', [[970,90], [970,250], [970,150], [728,90], [468,60]], 'psr-ads-psr_HgFc1eC');

        DoubleClickProvider.defineSlot('/8948849/psr_HgFc2eC', [[970,250], [970,150], [970,90], [728,90], [468,60]], 'psr-ads-psr_HgFc2eC');
        DoubleClickProvider.defineSlot('/8948849/psr_HgDc1eC', [[970,150], [970,90], [728,90], [468,60]], 'psr-ads-psr_HgDc1eC');
		DoubleClickProvider.defineSlot('/8948849/psr_HgDc1eC', [[970,150], [970,90], [728,90], [468,60]], 'psr-ads-psr_HgDc1eC');

        DoubleClickProvider.defineSlot('/8948849/psr_HpFc1eC', [[320, 50], [300, 50]], 'psr-ads-psr_HpFc1eC');
		DoubleClickProvider.defineSlot('/8948849/psr_HpFc2eC', [[320, 50], [300, 50]], 'psr-ads-psr_HpFc2eC');

		DoubleClickProvider.defineSlot('/8948849/1906x745', [1906, 745], 'psr-ads-1906x745');
		DoubleClickProvider.defineSlot('/8948849/190x35', [190, 35], 'psr-ads-190x35');

		$sceDelegateProvider.resourceUrlWhitelist(['self','http://*.personare.com.br/app/**','**']);
	}
]);

psrApp.run([
	'$rootScope',
	'user',
	'$window',
	function ($rootScope, user, $window) {
		if ( user.isAuthenticated() ) {
			$window.location.href = '/astrologia/horoscopo';
		} else {
			user.removeAuthenticationCookies();
		};
}]);

var fwBrowser = {
    browserName : '',
    version : '',
    matchMedia: '',
    isMobile: function()
    {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
            return true;
        }else{
            return false;
        }
    },
    checkBrowser: function()
    {
        if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
            this.browserName = 'ie';
            this.version = new Number(RegExp.$1);
        }else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'firefox';
            this.version = new Number(RegExp.$1);
        }else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'chrome';
            this.version = new Number(RegExp.$1);
        }else if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'opera';
            this.version = new Number(RegExp.$1);
        }else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'safari';
            this.version = new Number(RegExp.$1);
        }
        if(this.browserName != '' && this.version != ''){
            $('body').addClass(this.browserName)
            .addClass(this.browserName+this.version);
        }
    },
    checkMediaQuery: function(rule)
    {
        if( this.browserName == 'ie' && this.version <= 9 ){
            return false;
        }else{
            this.matchMedia = window.matchMedia( rule );
            if ( this.matchMedia.matches ) {
                return true;
            } else {
                return false;
            }
        }
    }
};

$(document).ready(function(){
    fwBrowser.checkBrowser();
});

(function(){
    var body = document.body || document.getElementsByTagName('body')[0];
    var iterator = 0,
        max = 20;
    var checkingTheBodySize = setInterval(function(){
        if (iterator === max) {
            window.clearInterval(checkingTheBodySize);
        } else {
            if (body.clientWidth <= 1010) {
                body.className += ' bodycombg';
                window.clearInterval(checkingTheBodySize);
            }
        }
        iterator++;
    }, 1000);
}());
